import { V3FileItem } from './file';

export interface PersonRef {
  id: number;
}

export interface PersonRefDetailed<T extends V3PersonDetails> extends PersonRef {
  details: T;
  accountId?: number;
  registrationEmail?: string;
}

export interface V3Person extends PersonRefDetailed<V3PersonDetails> {}

export enum RoleStatus {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  LOCKED = 'LOCKED',
  DELETED = 'DELETED',
}

export interface V3PersonDetails {
  name: string;
  surname: string;
}

export interface AccountRef {
  id: number;
}

export interface V3Account extends AccountRef {
  mail: string;
  status: AccountStatus;
}

export enum AccountStatus {
  ACTIVATING = 'ACTIVATING',
  ACTIVE = 'ACTIVE',
  LOCKED = 'LOCKED',
  DELETED = 'DELETED',
}

export interface ContactEntryRef {
  id: number;
}

export enum Gender {
  Male = 'Male',
  Female = 'Female',
  Other = 'Other',
}

export enum ContactType {
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
  SKYPE = 'SKYPE',
  WEBSITE = 'WEBSITE',
  CUSTOM = 'CUSTOM',
}

export interface V3ContactEntryDetails {
  name: string;
  value: string;
  entryType: ContactType;
  isDefault: boolean;
}

export interface V3ContactEntry
  extends ContactEntryRef,
    V3ContactEntryDetails {}

export interface V3Address {
  line1: string;
  line2: string;
  line3: string;
  city: string;
  country: string;
  postalCode: string;
  region: string;
}

export interface PersonInvitation<T extends V3PersonDetails> {
  email: string;
  details: T;
}

export interface V3PersonInvitationDetails extends V3PersonDetails {
  photo: V3FileItem;
  settings: V3Settings;
  sensitiveDetails: V3PersonalSensitiveDetails;
  address: V3Address;
  contactEntries: V3ContactEntry[];
}

export interface EmailChangeRequest {
  newEmail: string;
}

export interface VerifiedEmailChangeRequest extends EmailChangeRequest {
  managerPassword: string;
}

export interface PasswordChangeRequest {
  password: string;
}

export interface VerifiedPasswordChangeRequest
  extends PasswordChangeRequest {
  managerPassword: string;
}

export interface V3Settings {
  locale: string;
}

export interface V3PersonalSensitiveDetails {
  gender: Gender;
  nationality: string;
  birthDate: number;
  biography: string;
  studyReason: string;
}

export interface CountryDefinition {
  code: string;
  id: number;
  name: string;
  translations: Record<string, string>;
}
